import { Component, OnInit, Input } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { ActivatedRoute } from '@angular/router';
import { RefundReport, Store, AppState } from '../../../../store';

@Component({
  selector: 'app-refund-report',
  templateUrl: './refund-report.component.html',
  styleUrls: ['./refund-report.component.css']
})
export class RefundReportComponent extends ReportBase implements OnInit {

  report: RefundReport;
  controls = [
    { name: 'name', type: 'text', title: 'Name' },
    { name: 'dateRefund', type: 'date', title: 'Date' },
    { name: 'gender', type: 'select', title: 'Gender', options: [ { text: 'Male', value: 'm' }, { text: 'Female', value: 'f' } ] },
    { name: 'cardtype', type: 'select', title: 'Card Type', options: [] },
    { name: 'amountRefund', type: 'number', title: 'Amount' },
    { name: 'paymentID', type: 'text', title: 'Payment ID' }
  ];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.pullData('getRefundReportData');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/refund-report/refund-report.component.ts